import { PrivacyPolicy } from 'components/privacy-policy';

const PrivacyPolicyContainer = PrivacyPolicy;

export { PrivacyPolicyContainer };
